import * as Styles from './styles';

const formatDateForPeriod = (date: Date) =>
    date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });

export type SummaryCardConfig = {
    label: string;
    value: string;
    showPeriod: boolean;
    valueVariant: 'default' | 'deposits';
    isLoading?: boolean;
};

type SummaryCardProps = {
    config: SummaryCardConfig;
    startDate: Date;
    endDate: Date;
    isMobile?: boolean;
};

function SummaryCard({
    config,
    startDate,
    endDate,
    isMobile,
}: SummaryCardProps) {
    const ValueComponent =
        config.valueVariant === 'deposits'
            ? Styles.SummaryValueDeposits
            : Styles.SummaryValue;
    const MobileValueComponent =
        config.valueVariant === 'deposits'
            ? Styles.MobileMiniValueDeposits
            : Styles.MobileMiniValue;

    if (isMobile) {
        return (
            <Styles.MobileMiniSummaryCard>
                <Styles.MobileMiniLabel>{config.label}</Styles.MobileMiniLabel>
                {config.isLoading ? (
                    <Styles.ValueSkeleton />
                ) : (
                    <MobileValueComponent>{config.value}</MobileValueComponent>
                )}
            </Styles.MobileMiniSummaryCard>
        );
    }

    return (
        <Styles.SummaryCard>
            <Styles.SummaryLabel>{config.label}</Styles.SummaryLabel>
            {config.isLoading ? (
                <Styles.ValueSkeleton />
            ) : (
                <ValueComponent>{config.value}</ValueComponent>
            )}
            {config.showPeriod && (
                <Styles.SummaryPeriodLabel>
                    Period: {formatDateForPeriod(startDate)} -{' '}
                    {formatDateForPeriod(endDate)}
                </Styles.SummaryPeriodLabel>
            )}
        </Styles.SummaryCard>
    );
}

export default SummaryCard;
